module.exports = __webpack_public_path__ + "img/icon-pie.8c2ea3cf.png";